import { Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import Billing from "./pages/Billing";
import BillingProvincias from "./pages/BillingProvincias";
import Settlements from "./pages/Settlements";
import BindOperations from "./pages/BindOperations";
import AgExtracto from "./pages/AgExtracto";
import BindSaldos from "./pages/BindSaldos";
import BindStatus from "./pages/BindStatus";
import BindCertificates from "./pages/BindCertificates";
import CmfSaldos from "./pages/cmf/Saldos";
import CmfMovimientos from "./pages/cmf/Movimientos";
import CmfRecupero from "./pages/cmf/Recupero";
import CmfModificarCvu from "./pages/cmf/ModificarCvu";
import Monitoreo from "./pages/Monitoreo";
import MonitoreoPaises from "./pages/MonitoreoPaises";
import MonitoreoIps from "./pages/MonitoreoIps";
import MonitoreoCobros from "./pages/MonitoreoCobros";
import MonitoreoTransferencias from "./pages/MonitoreoTransferencias";
import MonitoreoCollectors from "./pages/MonitoreoCollectors";
import MonitoreoDashboard from "./pages/MonitoreoDashboard";
import MonitoreoSerieMensual from "./pages/MonitoreoSerieMensual";
import MonitoreoComplianceCmf from "./pages/MonitoreoComplianceCmf";
import MonitoreoEnlaces from "./pages/MonitoreoEnlaces";
import MonitoreoProveedores from "./pages/MonitoreoProveedores";
import MonitoreoIdCoelsa from "./pages/MonitoreoIdCoelsa";
import MonitoreoBuscador from "./pages/MonitoreoBuscador";
import CuitIntel from "./pages/CuitIntel";
import MonitoreoDominio from "./pages/MonitoreoDominio";
import Whitelist from "./pages/Whitelist";
import Access from "./pages/Access";
import Collectors from "./pages/Collectors";
import CollectorSplits from "./pages/CollectorSplits";
import CollectorDetail from "./pages/CollectorDetail";
import CollectorOperation from "./pages/CollectorOperation";
import CollectorMovements from "./pages/CollectorMovements";
import ComingSoon from "./pages/ComingSoon";
import OnboardingV2 from "./pages/OnboardingV2";
import Layout from "./components/Layout";
import { useAuth } from "./services/auth";

function Protected({ children }: { children: JSX.Element }) {
  const { token } = useAuth();
  return token ? children : <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <Protected>
            <Layout />
          </Protected>
        }
      >
        <Route index element={<Navigate to="/monitoreo/dashboard" replace />} />  {/* CP-482: Inicio = Dashboard */}
        <Route path="transfers-management" element={<ComingSoon title="Transfers to Suppliers Management" />} />
        <Route path="merchant" element={<ComingSoon title="Merchant Management" />} />
        <Route path="bind-status" element={<BindStatus />} />
        <Route path="check-movement" element={<ComingSoon title="Check movement" />} />
        <Route path="collector" element={<Collectors />} />
        <Route path="collector-splits" element={<CollectorSplits />} />
        <Route path="collector/:id" element={<CollectorDetail />} />
        <Route path="collector/:id/:tab" element={<CollectorDetail />} />
        <Route path="collector-operation" element={<CollectorOperation />} />
        <Route path="collector-operation/:id" element={<CollectorMovements />} />
        <Route path="onboarding" element={<OnboardingV2 />} />
        <Route path="onboarding/:id" element={<OnboardingV2 />} />
        <Route path="billing" element={<Billing />} />
        <Route path="billing-provincias" element={<BillingProvincias />} />
        <Route path="debines" element={<Settlements />} />
        <Route path="bind/movimientos" element={<BindOperations />} />
        <Route path="bind/saldos" element={<BindSaldos />} />
        <Route path="bind/ag-extracto" element={<AgExtracto />} />
        {/* back-compat: rutas viejas → Movimientos */}
        <Route path="bind/operations" element={<Navigate to="/bind/movimientos" replace />} />
        <Route path="bind-operations" element={<Navigate to="/bind/movimientos" replace />} />
        <Route path="bind-certificates" element={<BindCertificates />} />
        <Route path="cmf/saldos" element={<CmfSaldos />} />
        <Route path="cmf/movimientos" element={<CmfMovimientos />} />
        <Route path="cmf/recupero" element={<CmfRecupero />} />
        <Route path="cmf/modificar-cvu" element={<CmfModificarCvu />} />
        <Route path="monitoreo/dashboard" element={<MonitoreoDashboard />} />
        <Route path="monitoreo/apis" element={<Monitoreo />} />
        <Route path="monitoreo/paises" element={<MonitoreoPaises />} />
        <Route path="monitoreo/ips" element={<MonitoreoIps />} />
        <Route path="monitoreo/cobros" element={<MonitoreoCobros />} />
        <Route path="monitoreo/serie-mensual" element={<MonitoreoSerieMensual />} />
        <Route path="monitoreo/compliance-cmf" element={<MonitoreoComplianceCmf />} />
        <Route path="monitoreo/transferencias" element={<MonitoreoTransferencias />} />
        <Route path="monitoreo/collectors" element={<MonitoreoCollectors />} />
        <Route path="monitoreo/enlaces" element={<MonitoreoEnlaces />} />
        <Route path="monitoreo/proveedores" element={<MonitoreoProveedores />} />
        <Route path="monitoreo/id-coelsa" element={<MonitoreoIdCoelsa />} />
        <Route path="monitoreo/buscador" element={<MonitoreoBuscador />} />
        <Route path="monitoreo/buscar-cuit" element={<CuitIntel />} />
        <Route path="monitoreo/dominio" element={<MonitoreoDominio />} />
        <Route path="whitelist" element={<Whitelist />} />
        <Route path="access" element={<Access />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
